module["exports"] = [
  "sk",
  "com",
  "net",
  "eu",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/internet/domain_suffix.js
// module id = 1232
// module chunks = 0